module.exports = __webpack_public_path__ + "img/about-img_2.f14fad69.png";